import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { LiftsComponent } from '@app/lift/lifts.component';
import { LiftListComponent } from './components/lift-list/lift-list.component';
import { LiftCreateModalComponent } from '@app/lift/components/lift-create-modal/lift-create-modal.component';
import { LiftDetailsComponent } from './containers/lift-details/lift-details.component';
import { LiftsListComponent } from '@app/lift/containers/lift-list/lifts-list.component';
import { StoreModule } from '@ngrx/store';
import * as fromLifts from './store/lifts.reducer';
import { LiftsEffects } from '@app/lift/store/lifts.effects';
import { EffectsModule } from '@ngrx/effects';
import { LiftsService } from '@app/lift/service/lifts.service';
import { LiftNotificationsEffects } from '@app/lift/lift.notifications';
import { environment } from '../../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LiftMockInterceptor } from '@app/lift/mocks/lift.mock';
import { TrayComponent } from './components/tray/tray.component';
import { TrayDetailsComponent } from './containers/tray-details/tray-details.component';
import { SlotComponent } from './components/slot/slot.component';
import { ToolModule } from '@app/tool/tool.module';
import { LiftToolsTableComponent } from './components/lift-tools-table/lift-tools-table.component';
import { ToolModalComponent } from './components/tool-modal/tool-modal.component';
import { BatchComponent } from './components/batch/batch.component';
import { AddToBatchModalComponent } from '@app/lift/components/add-batch-modal/add-to-batch-modal.component';
import { BatchService } from '@app/lift/service/batch.service';
import { RemoveFromBatchModalComponent } from '@app/lift/components/remove-batch-modal/remove-from-batch-modal.component';
import { EditSlotModalComponent } from '@app/lift/components/edit-slot-modal/edit-slot-modal.component';
import { RenameCartModalComponent } from './components/rename-cart-modal/rename-cart-modal.component';
import { EditBatchComponent } from './components/edit-batch/edit-batch.component';
import { EditTrayModalComponent } from './components/edit-tray-modal/edit-tray-modal.component';
import { CopySlotModalComponent } from './components/copy-slot-modal/copy-slot-modal.component';
import { CopyBatchesModalComponent } from './components/copy-batches-modal/copy-batches-modal.component';
import { SelectBatchesFormComponent } from './components/copy-batches-modal/forms/select-batches-form/select-batches-form.component';
import { SelectSlotFormComponent } from './components/copy-batches-modal/forms/select-slot-form/select-slot-form.component';
import { LiftToolFiltersComponent } from './components/lift-tool-filters/lift-tool-filters.component';

// Providers used to create fake backend
let liftMocks: any[] = [];

if (environment.mocks.lifts) {
    liftMocks = [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LiftMockInterceptor,
            multi: true
        }
    ]
}

@NgModule({
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        ToolModule,
        // LiftsRoutingModule,
        StoreModule.forFeature(fromLifts.liftsFeatureKey, fromLifts.reducer),
        EffectsModule.forFeature([LiftsEffects, LiftNotificationsEffects]),
    ],
    declarations: [
        LiftsComponent,
        LiftListComponent,
        LiftCreateModalComponent,
        LiftDetailsComponent,
        LiftsListComponent,
        LiftToolFiltersComponent,
        TrayComponent,
        TrayDetailsComponent,
        SlotComponent,
        LiftToolsTableComponent,
        ToolModalComponent,
        AddToBatchModalComponent,
        RemoveFromBatchModalComponent,
        BatchComponent,
        EditSlotModalComponent,
        RenameCartModalComponent,
        EditBatchComponent,
        EditTrayModalComponent,
        CopySlotModalComponent,
        CopyBatchesModalComponent,
        SelectBatchesFormComponent,
        SelectSlotFormComponent
    ],
    exports: [
        LiftsComponent,
        LiftCreateModalComponent,
        LiftsListComponent
    ],
    providers: [
        liftMocks,
        LiftsService,
        BatchService
    ]
})
export class LiftsModule {

}
